import SimplePage from "@/components/layout/SimplePage";

export default function Shabbat() {
  return (
    <SimplePage
      title="Shabbat at Our Melbourne FL Synagogue"
      eyebrow="The Heart of the Week"
      subtitle="Music-filled, heartfelt Friday-night services led by Rabbi Karen Fanwick. All are welcome at the Reform synagogue in Melbourne, Florida."
      description="Friday-night Shabbat services at Temple Israel of Brevard, the Reform synagogue in Melbourne, FL. 7:00 PM every Friday. All are welcome - members and visitors alike."
      path="/worship/shabbat"
      ctaLabel="See full calendar"
      ctaTo="/events"
    >
      <div style={{ background: "var(--honey)", borderLeft: "5px solid var(--blue-deep)", padding: "1rem 1.25rem", borderRadius: "12px", margin: "0 0 1.75rem" }} data-testid="shabbat-time-alert">
        <strong style={{ color: "var(--blue-ink)" }}>Service times can change.</strong>{" "}
        Shabbat services <em>usually</em> begin at 7:00 PM, but a few times each
        year the time shifts for special services, holidays, or seasonal
        gatherings. <a href="/" style={{ color: "var(--blue-deep)", textDecoration: "underline", fontWeight: 600 }}>Check the home page for this week&rsquo;s exact time</a>{" "}
        before you head out - there is nothing more frustrating than walking in
        halfway through, or after, a service has ended.
      </div>

      <h2>Friday Evening Service</h2>
      <p>
        Our weekly Shabbat service typically begins at{" "}
        <strong>7:00 PM every Friday</strong> in the sanctuary at 7300 Lake
        Andrew Drive. Services are open to all &mdash; members and visitors
        alike. No reservation is needed, no ticket required.
      </p>
      <p>
        <strong>Confirm the week&rsquo;s exact start time on the home page or in
        the TIoB Weekly newsletter before you leave home.</strong> Occasional
        Shabbatot are moved earlier or later for family services, guest
        musicians, and holiday timing.
      </p>
      <p>
        Rabbi Fanwick leads our community in a service that blends traditional
        Reform liturgy with music, learning, and warmth. We sing, we pray, we
        reflect, and we welcome Shabbat together. The service is followed by an{" "}
        <em>oneg Shabbat</em> reception - a chance to enjoy refreshments and
        meet members of the community.
      </p>

      <h2>Torah Study</h2>
      <p>
        Saturday morning at <strong>9:30 AM</strong>, Rabbi Fanwick leads a
        lively discussion of the weekly Torah portion in her office &mdash; and
        it&rsquo;s simultaneously available on Zoom for anyone who can&rsquo;t
        make the drive. All levels welcome, no prior Hebrew or background
        required. Drop in any Saturday.
      </p>

      <h2>What to Expect on Your First Visit</h2>
      <ul>
        <li><strong>Dress code:</strong> Smart casual. There is no formal dress code.</li>
        <li><strong>Head coverings:</strong> Kippot (yarmulkes) and tallitot (prayer shawls) are available at the entrance to the sanctuary if you'd like to wear one.</li>
        <li><strong>Prayer books:</strong> Provided. Pages are announced; you do not need to read Hebrew.</li>
        <li><strong>Accessibility:</strong> The sanctuary is wheelchair accessible. Large-print prayer books are available - ask the greeter.</li>
        <li><strong>Children:</strong> Always welcome. A small children&rsquo;s play room is available in the room just off the sanctuary.</li>
      </ul>

      <h2>Special Shabbat Services</h2>
      <p>
        Throughout the year we host special Shabbat experiences - Shabbat Under
        the Stars (outdoor service), guest musician Shabbatot, intergenerational
        family services, healing Shabbatot, and Shabbat dinners. See the{" "}
        <a href="/events">events calendar</a> or our weekly bulletin for upcoming dates.
      </p>
    </SimplePage>
  );
}
